import { render, staticRenderFns } from "./BiodigestorAssetSummaryCardWidgetComponent.vue?vue&type=template&id=03ff1e07&"
import script from "./BiodigestorAssetSummaryCardWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./BiodigestorAssetSummaryCardWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports